





































import { Component } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import ManuallyPostInterestRequest from '@/models/Accounts/DepositAccounts/Wallets/ManuallyPostInterestRequest';

@Component({ name: 'WalletManuallyPostInterestDialog' })
export default class extends SaascadaVueDialog {

    dialog = false;
    request = new ManuallyPostInterestRequest();

    async confirm() {
        this.dialog = false;
        this.request.accountId = DepositAccountModule.depositAccount.id;
        await DepositAccountModule.manuallyPostInterest(this.request);
    }

}
